import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { usePayrollPrices } from '../payrollPrice.hooks'
import { fetchContractors, fetchEmployees } from '../payrollActions'
import { Text, Card, Button, Alert, Icon, CardColors } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles, TextColors } from '@/styles'

export const CreateTeamMember = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isEmployee, setIsEmployee] = useState(true)
  const [numOfEmp, setNumOfEmp] = useState(0)
  const { seat } = usePayrollPrices()

  const navigateToCreate = useCallback(() => {
    if (isEmployee) {
      navigate('/payroll/create_employee')
    } else {
      navigate('/payroll/create_contractor')
    }
  }, [isEmployee, navigate])

  useEffect(() => {
    const fetch = async () => {
      const empRes = await fetchEmployees()(dispatch)
      const contRes = await fetchContractors()(dispatch)

      if (empRes && contRes) {
        setNumOfEmp(empRes.length + contRes.length)
      }
    }

    fetch()
  }, [dispatch])

  return (
    <Card>
      <div className="flex flex-col gap-6">
        <Text variant={TypographyStyles.H1}>Add a new team member</Text>
        <Text variant={TypographyStyles.BODY_MD}>
          Congrats on growing your team!
        </Text>

        {Boolean(numOfEmp) && (
          <Alert>
            <b>Note:</b> You are currently paying for{' '}
            <b>{numOfEmp} team member(s)</b>. Adding a new team member will add{' '}
            {seat ? <b>{seat}/month</b> : 'a monthly charge'} to your plan.
          </Alert>
        )}

        {/* <div className="flex flex-col sm:flex-row gap-2">
          <Button
            onClick={() => setIsEmployee(true)}
            variant="primary"
            className={`flex flex-col h-fit ${isEmployee ? 'active' : ''}`}
          >
            <Text variant={TypographyStyles.H2} color={TextColors.WHITE}>
              Employee
            </Text>
            <Text className="text-center" color={TextColors.WHITE}>
              A person who works for wages or a set salary and receives
              benefits.
            </Text>
          </Button>

          <Button
            onClick={() => setIsEmployee(false)}
            variant="primary"
            className={`flex flex-col h-fit${!isEmployee ? 'active' : ''}`}
          >
            <Text variant={TypographyStyles.H2} color={TextColors.WHITE}>
              Contractor
            </Text>
            <Text className="text-center" color={TextColors.WHITE}>
              A person who provides a service for pay.
            </Text>
          </Button>
        </div> */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Card
            color={isEmployee ? CardColors.LEVEL_0 : CardColors.LEVEL_1}
            onClick={() => setIsEmployee(true)}
            className={`cursor-pointer border transition-all p-4 w-full sm:w-1/2 ${
              isEmployee
                ? 'border-green-200 bg-green-0'
                : 'border-muted hover:border-gray-200'
            }`}
          >
            <Text
              variant={TypographyStyles.H3}
              className="text-center pb-4"
              color={isEmployee ? TextColors.BRAND : TextColors.DEFAULT}
            >
              Employee
            </Text>
            <Text
              variant={TypographyStyles.BODY_MD}
              className="text-center text-muted-foreground"
            >
              A person who works for wages or a set salary and receives
              benefits.
            </Text>
          </Card>

          <Card
            color={!isEmployee ? CardColors.LEVEL_0 : CardColors.LEVEL_1}
            onClick={() => setIsEmployee(false)}
            className={`cursor-pointer border transition-all p-4 w-full sm:w-1/2 ${
              !isEmployee
                ? 'border-green-200 bg-green-0'
                : 'border-muted hover:border-gray-200'
            }`}
          >
            <Text
              variant={TypographyStyles.H3}
              className="text-center pb-4"
              color={!isEmployee ? TextColors.BRAND : TextColors.DEFAULT}
            >
              Contractor
            </Text>
            <Text
              variant={TypographyStyles.BODY_MD}
              className="text-center text-muted-foreground"
            >
              A person who provides a service for pay.
            </Text>
          </Card>
        </div>

        <Text variant={TypographyStyles.BODY_MD}>
          Don’t worry — you can always remove or change the status of team
          members in the future!
        </Text>

        <div className="w-full sm:w-1/4">
          <Button onClick={navigateToCreate} className="w-full">
            Continue
            <Icon
              icon={faArrowRight}
              className="ml-2"
              color={TextColors.WHITE}
            />
          </Button>
        </div>
      </div>
    </Card>
  )
}
